import * as React from 'react'
import { FC } from 'react'

import { color } from '../../../../../style/variables'

interface MenuButtonProps {
  onClick: () => void
  isMenuOpen: boolean
}

const MenuButton: FC<MenuButtonProps> = ({ onClick, isMenuOpen }) => {
  return (
    <>
      <style jsx>{`
        .menu-button {
          margin: auto 20px auto 0;
          cursor: pointer;
        }
        .menu-button svg {
          display: block;
        }
        .button {
          fill: ${color.brandPrimary};
        }
        .button:hover {
          fill: #bf0808;
        }
      `}</style>
      <div className="menu-button" onClick={onClick}>
        {isMenuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="6 6 20 20">
            <g fill="none" fillRule="evenodd">
              <path
                className="button"
                d="M25.333 8.547L23.453 6.667 16 14.12 8.547 6.667 6.667 8.547 14.12 16 6.667 23.453 8.547 25.333 16 17.88 23.453 25.333 25.333 23.453 17.88 16z"
              />
            </g>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="20 24 24 16">
            <g fill="none" fillRule="evenodd">
              <path className="button" d="M20 40h24v-2.667H20V40zm0-6.667h24v-2.666H20v2.666zM20 24v2.667h24V24H20z" />
            </g>
          </svg>
        )}
      </div>
    </>
  )
}
export default MenuButton
